// The support WhatsApp number (+27 69 029 9781) — answered by the assistant
// bot with the team reading along. Rendered wherever a player might be stuck.
//
// The message carries a short debug block so nobody has to interview a
// stranded player for the basics (Mel, 2026-08-22): who they are, which game,
// which screen, and what broke. The bot reads the chat, so the block is
// labelled rather than prose, and the player can see exactly what they are
// sending — nothing is collected that they can't read in the draft.
import { trackWhatsAppSupport } from '../../utils/helpAnalytics';

const SUPPORT_NUMBER = '27690299781';

/** How much of an error message is worth carrying into a chat window. */
const ERROR_MAX = 140;

function readLocal(key) {
  try { return window.localStorage.getItem(key) || ''; } catch { return ''; }
}

/** The game code travels in the URL (?code=1705), not in storage. */
function codeFromUrl() {
  try { return new URLSearchParams(window.location.search).get('code') || ''; } catch { return ''; }
}

/**
 * Build the prefilled support message.
 * Accepts a bare code for the older call sites, or a context object.
 */
export function supportMessage(ctx = {}) {
  const { code, player, screen, error, step } = typeof ctx === 'string' ? { code: ctx } : ctx;
  const gameCode = code || codeFromUrl();
  const name = player || readLocal('username');
  // "Screen: /" tells support nothing, so the root path counts as unknown.
  const raw = screen || (typeof window !== 'undefined' ? window.location.pathname : '');
  const path = raw && raw !== '/' ? raw : '';
  const detail = String(error?.message || error || '').trim().slice(0, ERROR_MAX);

  const lines = ['Hi! I need help with my Tasted game.'];
  const facts = [
    gameCode && `Game: ${gameCode}`,
    name && `Player: ${name}`,
    path && `Screen: ${path}`,
    Number.isInteger(step) && `Step: ${step}`,
    detail && `Error: ${detail}`,
  ].filter(Boolean);
  if (facts.length) lines.push('', '--- for support ---', ...facts);
  return lines.join('\n');
}

export function whatsappSupportUrl(ctx) {
  return `https://wa.me/${SUPPORT_NUMBER}?text=${encodeURIComponent(supportMessage(ctx))}`;
}

export default function WhatsAppSupportLink({ code, player, screen, error, step, className = '', label = 'WhatsApp support', via }) {
  return (
    <a
      href={whatsappSupportUrl({ code, player, screen, error, step })}
      onClick={() => trackWhatsAppSupport(via || (error ? 'error_screen' : 'support_link'), code || codeFromUrl() || null)}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {label}
    </a>
  );
}
